<template>
	<div>
		<modal ref="modal" @modal-fechou="() => modalFechou()">
			<div style="min-height: 400px">
				<button type="button" class="close" @click="$refs.modal.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>

				<!-- lista com dos despachos -->
				<div v-if="exibir == 'LD'">
					<h4 class="modal-title" v-if="!dbComercial">
						{{ 
							titulo != ''
							? _traducao('global', 'selecione').toUpperCase() + " UM " + titulo.toUpperCase()
							: _traducao('global', 'selecionarUmDespacho').toUpperCase() 
						}} 
					</h4>
					<h4 class="modal-title" v-if="dbComercial">
						{{ _traducao('global', 'selecionarUmaProgramacao').toUpperCase() }}
					</h4>

					<hr style="margin-top: 6px" />

					<div class="row">
						<div class="col-xs-12">
							<p
								class="text-info"
								v-if="temAeronave && !dbComercial && !despachoSemAero"
							>
								<i class="fa fa-fw fa-info-circle"></i
								>
								{{
									titulo != ''
									? `Abaixo estão listados todos os ${titulo.toLocaleLowerCase()}s em aberto. Selecione na lista ou insira um novo ${titulo.toLocaleLowerCase()}`
									: _traducao('global', 'despachosDisponiveis') 
								}}
							</p>
							<p
								class="text-info"
								v-else-if="temAeronave && dbComercial && !despachoSemAero"
							>
								<i class="fa fa-fw fa-info-circle"></i
								>{{ _traducao('global', 'despachosProgramacoesDisponiveis') }}
							</p>
							<p
								class="text-info"
								v-else-if="temAeronave && !dbComercial && despachoSemAero"
							>
								<i class="fa fa-fw fa-info-circle"></i
								>
								{{
									titulo != ''
									? `Não encontramos nenhum ${titulo.toLocaleLowerCase()} em aberto para essa aeronave. Escolha um ${titulo.toLocaleLowerCase()} listado ou insira um novo ${titulo.toLocaleLowerCase()}`
									:_traducao('global', 'despachosDisponiveisSemAero') 
								}}
							</p>
							<p
								class="text-info"
								v-else-if="temAeronave && dbComercial && despachoSemAero"
							>
								<i class="fa fa-fw fa-info-circle"></i
								>{{ _traducao('global', 'despachosProgramacaoSemAero') }}
							</p>
							<p class="text-info" v-else-if="!temAeronave && !dbComercial">
								<i class="fa fa-fw fa-info-circle"></i
								>{{ _traducao('global', 'despachosNaoDisponiveis') }}
							</p>
							<p class="text-info" v-else-if="!temAeronave && dbComercial">
								<i class="fa fa-fw fa-info-circle"></i
								>{{
									_traducao('global', 'despachosProgramacoesNaoDisponiveis')
								}}
							</p>
						</div>
					</div>

					<div v-show="despachos.length > 0" class="row form-group">
						<div class="col-xs-12">
							<i class="fa fa-search icone-busca" aria-hidden="true"></i>
							<input
								type="text"
								style="padding-left: 22px; margin-top: 7px"
								:placeholder="_traducao('global', 'buscar')"
								v-model.trim="buscaDespacho"
								class="form-control"
							/>
						</div>
					</div>

					<div class="row" style="margin-top: 4px">
						<div class="col-sm-12">
							<div
								ref="scrollDespacho"
								class="scroll"
								style="overflow-y: scroll"
								:style="{'max-height': this._height - 250 + 'px'}"
							>
								<div class="table-responsive">
									<table
										class="table table-lista table-striped table-siga table-hover"
									>
										<thead>
											<tr>
												<th style="width: 15%" v-if="!dbComercial">
													{{ 
														titulo != ''
														?  "Nº" + " do " + titulo.toUpperCase()
														: _traducao('global', 'numeroDoDespacho') 
													}}
												</th>
												<th style="width: 10%" v-if="dbComercial">
													{{ _traducao('global', 'numeroDaProgramacao') }}
												</th>

												<th v-if="dbComercial">
													{{ _traducao('global', 'identificacaoVoo') }}
												</th>
												<th v-else-if="naoDefinirTipo == 0">{{ _traducao('global', 'tipo') }}</th>
												<th v-if="dbComercial">
													{{ _traducao('global', 'trecho') }}
												</th>
												<th>{{ _traducao('global', 'historico') }}</th>

												<th style="width: 15%">
													{{ _traducao('global', 'aeronave') }}
												</th>

												<th style="width: 10%" class="text-center">
													{{ _traducao('global', 'base') }}
												</th>
												<th style="width: 10%" class="text-center">
													<div
														class="d-flex align-items-center"
														@click.prevent="clickOrdenar()"
													>
														<!-- crescente -->
														<svg
															v-show="ordenacao.sentidoCrescente"
															xmlns="http://www.w3.org/2000/svg"
															fill="none"
															viewBox="0 0 24 24"
															stroke-width="1.5"
															stroke="currentColor"
															style="
																width: 16px;
																height: 16px;
																margin-left: -6px;
															"
														>
															<path
																stroke-linecap="round"
																stroke-linejoin="round"
																d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"
															/>
														</svg>
														<!-- descendente -->
														<svg
															v-show="!ordenacao.sentidoCrescente"
															xmlns="http://www.w3.org/2000/svg"
															fill="none"
															viewBox="0 0 24 24"
															stroke-width="1.5"
															stroke="currentColor"
															style="
																width: 16px;
																height: 16px;
																margin-left: -6px;
															"
														>
															<path
																stroke-linecap="round"
																stroke-linejoin="round"
																d="M8.25 6.75L12 3m0 0l3.75 3.75M12 3v18"
															/>
														</svg>
														{{ _traducao('global', 'inicio') }}
													</div>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												class="table-hover-tr"
												@click="clickSelecinouDespacho(item)"
												v-for="(item, index) in _despachos"
												:key="index"
											>
												<td>
													{{ item.numero }}
												</td>
												<td v-if="dbComercial">
													<span v-if="item.numero_voo">
														{{ item.numero_voo }}<br />
													</span>
													<span v-else> {{ item.identificacao }}<br /> </span>
												</td>
												<td v-else-if="naoDefinirTipo == 0">
													{{ item._tipo }}<br />
													<small v-if="item.id_ordem_missao != null">{{
														item.ordem_codigo
													}}</small>
												</td>
												<td v-if="dbComercial">
													<div v-for="trecho in item.aeronave[0].trecho">
														<span>
															{{ trecho.designativo_partida }}
															<i class="fa fa-arrow-right" />
															{{ trecho.designativo_destino || 'ZZZZ' }}
														</span>
														<br />
													</div>
												</td>
												<td>
													{{ item.historico }}
												</td>
												<td>
													<span v-for="(aero, idx) in item.aeronave" :key="idx">
														<span
															v-for="(a, i) in aeronaves"
															:key="i"
															v-if="a.id == aero.id_aeronave"
															>{{ a.codinome }} - {{ a.prefixo }}</span
														><br />
													</span>
												</td>
												<td class="text-center">
													<span v-for="(aero, idx) in item.aeronave" :key="idx">
														<span
															v-for="b in bases"
															:key="b.descricao"
															v-if="b.id == aero.base"
															>{{ b.descricao }}</span
														><br />
													</span>
												</td>
												<td class="text-center">
													{{ item.data_inicio | dataTempo }}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div>
						<hr style="margin-top: 6px" />
						<div class="row" v-if="!dbComercial">
							<div class="col-xs-12">
								<button
									type="button"
									class="btn btn-default"
									@click="clickAddDespacho()"
								>
									<i class="fa fa-fw fa-plus"></i>
									{{ 
									  titulo != ''
									  ? _traducao('global','adicionar').toUpperCase() + " " + titulo.toUpperCase()
										:_traducao('global', 'adicionarDespacho').toUpperCase() 
									}}
								</button>
							</div>
						</div>
						<div class="row" v-else>
							<div class="col-xs-12">
								<button
									type="button"
									class="btn btn-default"
									@click="clickAddProgramacao()"
								>
									<i class="fa fa-fw fa-plus"></i>
									{{ _traducao('global', 'adicionarProgramacaoVoo') }}
								</button>
							</div>
						</div>
					</div>
				</div>

				<!-- novo despacho -->
				<div v-if="exibir == 'NO'">
					<h4 class="modal-title">
						{{ 
						  titulo != ''
							? _traducao('global', 'novo').toUpperCase() + " " + titulo.toUpperCase()
							: _traducao('global', 'novoDespacho').toUpperCase() 
						}}
					</h4>

					<flDespacho
						:visualizar="false"
						@despacho-add="(despacho) => addDespacho(despacho)"
						:aeronaves="aeronaves"
						:contextos="contextos"
						:orgaosApoiados="orgaos"
						:classificacoes="classificacoes"
						:subclassificacoes="subclassificacoes"
						ref="despachoCadastro"
					/>
				</div>
				<div v-if="exibir == 'PO' && dbComercial">
					<flProgramacao
						:visualizar="false"
						@despacho-add="(despacho) => addProgramacao(despacho)"
						:aeronaves="aeronaves"
						:bases="bases"
						:orgaos-apoiados="orgaos"
						:contextos="contextos"
						:subclassificacoes="subclassificacoes"
						:programacao-diario="true"
						ref="programacaoCadastro"
					/>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import flDespacho from '../../../despacho/mg-siga/cadastro.vue'
import flProgramacao from '../../../despacho-comercial/cadastro.vue'
export default {
	components: {
		flDespacho,
		flProgramacao
	},

	data() {
		return {
			tipo: '',
			despacho: '',
			despachos: [],
			despachosAeronave: [],
			bases: [],
			aeronave: {},
			orgaos: [],
			buscaDespacho: '',

			ordenacao: {
				sentidoCrescente: true
			},

			ordens: [],

			listaPlanejada: '',

			exibir: '',
			temAeronave: false,
			despachoSemAero: false,

			aeronaves: [],
			contextos: [],
			classificacoes: [],
			subclassificacoes: [],
			dbComercial: false,
			despachoSelecionado: false,
			titulo: '',
			naoDefinirTipo: 0,
		}
	},

	computed: {
		_despachos() {
			if (this.buscaDespacho == '') {
				if (this.despachosAeronave.length > 1) {
					if (!this.ordenacao.sentidoCrescente) {
						return _.orderBy(this.despachosAeronave, ['data_inicio'], ['desc'])
					}
					return _.orderBy(this.despachosAeronave, ['data_inicio'], ['asc'])
				} else {
					if (!this.ordenacao.sentidoCrescente) {
						return _.orderBy(this.despachos, ['data_inicio'], ['desc'])
					}
					return _.orderBy(this.despachos, ['data_inicio'], ['asc'])
				}
			}

			var self = this
			var list = (
				this.despachosAeronave.length > 0
					? this.despachosAeronave
					: this.despachos
			).filter(function (cust) {
				const searchString = self.buscaDespacho.toLowerCase()
				const converterData = (input) => {
					const [datePart, timePart] = input.split(' ')
					const [year, month, day] = datePart.split('-')
					return `${day}/${month}/${year} ${timePart}`
				}

				const matchNumero = cust.numero.toLowerCase().includes(searchString)
				const matchHistorico =
					cust.historico && cust.historico.toLowerCase().includes(searchString)
				const matchTipo = cust._tipo.toLowerCase().includes(searchString)
				const matchAeronave =
					cust.aeronave &&
					cust.aeronave[0].prefixo &&
					cust.aeronave[0].prefixo.toLowerCase().includes(searchString)
				const matchIdentificacao =
					cust.identificacao &&
					cust.identificacao.toLowerCase().includes(searchString)
				const matchInicio = converterData(cust.data_inicio)
					.toLowerCase()
					.includes(searchString)
				const matchBase =
					cust.aeronave[0] && cust.aeronave[0].base
						? self.bases
								.find((base) => base.id === cust.aeronave[0].base)
								.descricao.toLowerCase()
								.includes(searchString)
						: false

				return (
					matchNumero ||
					matchHistorico ||
					matchTipo ||
					matchAeronave ||
					matchIdentificacao ||
					matchInicio ||
					matchBase
				)
			})

			if (!this.ordenacao.sentidoCrescente) {
				return _.orderBy(list, ['data_inicio'], ['desc'])
			}
			return _.orderBy(list, ['data_inicio'], ['asc'])
		}
	},

	created() {
		this._getParametro(110).then(
			(valor) => (this.dbComercial = Number(valor) == 1)
		)
		this._getParametro(185).then((valor) => (this.titulo = valor))
		this._getParametro(187).then((valor) => (this.naoDefinirTipo = valor))
		this._providerBaseOperacional((lista) => (this.bases = lista))

		var configScroll = {
			color: '#AAA',
			size: '5px',
			height: this._height - 600 + 'px',
			alwaysVisible: true,
			railOpacity: 0.9
		}

		this.$nextTick(() => {
			$(this.$refs.scrollDespacho).slimScroll(configScroll)
		})
	},

	methods: {
		clickOrdenar() {
			this.ordenacao.sentidoCrescente = !this.ordenacao.sentidoCrescente
		},
		clickSelecinouDespacho(despacho) {
			this.emitEventoDespacho(despacho)
		},

		clickAddProgramacao() {
			this.exibir = 'PO'
			//this.$refs.modal.changeWidh(90)
			//this.$nextTick(() => {
			//this.$refs.programacaoCadastro.openModal(this.aeronave)
			//})
		},

		clickAddDespacho() {
			this.exibir = 'NO'

			this.$refs.modal.changeWidh(90)
			this.$nextTick(() => {
				this.$refs.despachoCadastro.novoModal(this.aeronave)
			})
		},

		carregaDespachos() {
			this.listaPlanejada = 'D'

			if (this.despachos.length == 0) {
				this.exibir = 'LD'
				this.validaDespacho(true)
			}
		},

		addProgramacao(programacao) {
			bus.$emit('exibir-notificacao', {
				type: 'success',
				text: 'Programacão salva.'
			})
			this.emitEventoDespacho(programacao)
		},

		addDespacho(despacho) {
			bus.$emit('exibir-notificacao', {
				type: 'success',
				text: this.titulo !="" ? this.titulo + " " + this._traducao('global','salvo'): 'Despacho salvo.'
			})
			this.emitEventoDespacho(despacho)
		},

		emitEventoDespacho(despacho) {

			this.despacho = despacho
			this.$refs.modal.modalHide()
		},

		modalFechou() {
			if (this.despacho != '') {
				this.$emit('selecionou-despacho', {...this.despacho, showTrechos: true})
			}
		},

		validaDespacho(
			alteraDespacho = false,
			despachoExiste = false,
			trechoMultiplo = false,
			modificar = false
		) {
			bus.$emit('load-in', {text: this._traducao('global', 'carregandoDados')})

			let params = ''
			if (despachoExiste) {
				params = '/' + despachoExiste
			}
			this._httpGet(
				'mg-siga/Despacho_emergencial/get_aberto_no_pagination' + params,
				(response) => {
					bus.$emit('load-out')
					if (response._request) {
						response.lista = response.lista.map((item) => {
							if (item.tipo == 'P') {
								item._tipo = 'PLANEJADA'
							}

							if (item.tipo == 'C') {
								item._tipo = 'CRÍTICA'
							}

							if (item.tipo == 'E') {
								item._tipo = 'EMERGENCIAL'
							}

							if (item.tipo == 'Q') {
								item._tipo = 'PREVENTIVA'
							}

							const countAeronaves = item.aeronave.length
							for (let i = 0; i < countAeronaves; i++) {
								let countTrecho = item.aeronave[i].trecho.length
								for (let j = 0; j < countTrecho; j++) {
									item.trecho = []
									item.trecho.push(item.aeronave[i].trecho[j])
								}
							}
							return item
						})

						if (despachoExiste) {
							const despachoGerado = response.lista.find(
								(despacho) => despacho.id == despachoExiste
							)
							despachoGerado.trechoMultiplo = trechoMultiplo
							this.$emit('selecionou-despacho', despachoGerado)
					
							this.despachoSelecionado = true
							return
						}

						if (response.lista.length == 1) {
							if (this.despachoSelecionado == false) {
								this.$emit('selecionou-despacho', response.lista[0])
								this.despachoSelecionado = true
							} else {
								this.$refs.modal.modalShow(80)
								this.clickAddDespacho()
							}
						} else {
							if (response.lista.length == 0) {
								this.temAeronave = false
							} else if (response.lista.length > 1) {
								this.temAeronave = true
							}
							this.despachos = response.lista
							this.despachosAeronave = this.despachos.filter((aero) => {
								if (aero.aeronave.length > 0) {
									for (let contador in aero.aeronave) {
										if (
											this.aeronave.id == aero.aeronave[contador].id_aeronave
										) {
											return true
										}
									}
								}
								return false
							})
							if (this.despachosAeronave.length == 1 && !alteraDespacho) {
								if (this.despachoSelecionado == false) {
									this.$emit('selecionou-despacho', this.despachosAeronave[0])
									this.despachoSelecionado = true
								} else {
									this.$refs.modal.modalShow(80)
									this.clickAddDespacho()
								}
							} else if (
								(this.despachosAeronave.length == 0 &&
									this.despachos.length > 0) ||
								alteraDespacho
							) {
								this.despachoSemAero = true
							}

							if (alteraDespacho) {
								this.despachosAeronave = this.despachos
							}
							this.exibir = 'LD' // exibe a lista de despachos
							if (modificar || !this.despachoSelecionado) {
								this.$refs.modal.modalShow(80)
							}
						}
					}
				}
			)
		},

		limpaForm() {
			this.despacho = ''
			this.despachos = []
			this.aeronave = {}
			this.buscaDespacho = ''
			this.ordens = []
			this.listaPlanejada = ''
			this.exibir = ''
			this.temAeronave = false
			this.evento = {}
		},

		carregaDados(aeronave, alteracao = false, modificar = false) {
			this.limpaForm()

			this.aeronave = aeronave
			this.validaDespacho(false, alteracao, false, modificar)

			this._providerContextoOperativo((lista) => {
				this.contextos = lista
			})

			// AERONAVE
			this._providerAeronave((lista) => {
				this.aeronaves = lista
			})

			this._providerClassificacao((lista) => {
				this.classificacoes = lista
			})

			this._providerSubclassificacao((lista) => {
				this.subclassificacoes = lista
			})

			this._providerOrgaoApoiado((lista) => {
				this.orgaos = lista
			})
		}
	}
}
</script>

<style>
.table-hover-tr:hover td {
	background: #f0f0f0;
	cursor: pointer;
}

.bk-success {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}
</style>